// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { RechnungDaten } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useSaveAndResendDatev(): (
  rechnungId: string,
  requestBody: RechnungDaten
) => Promise<void> {
  const getAPI = useGetApi();
  return useCallback(
    async (rechnungId, requestBody) =>
      (await getAPI()).rechnungen.saveAndResendDatev({
        rechnungId,
        requestBody,
      }),
    [getAPI]
  );
}
